import { Empty, Row } from 'antd';
import React from 'react';
import IconCameraEmpty from '../../../assets/icons/camera-empty.svg';
import CameraItem from '../CameraItem';
import clsx from 'classnames';
import { useSelector } from 'react-redux';

const CameraList = ({
  data,
  isSeeking,
  getAppearanceTimeStyle,
  playerRefs,
  handleProgress,
  handleFullScreen,
  setLayoutMode,
  setSelectedStream,
  layout,
}) => {
  const { generateLinkStorageFileByTime } = useSelector(state => state);

  if (!data || data.length === 0) {
    return (
      <Empty
        style={{ margin: 80 }}
        image={IconCameraEmpty}
        imageStyle={{ height: 100 }}
        description={<span>No cameras to view!</span>}
      />
    );
  }

  return (
    <Row
      gutter={[16, 16]}
      className={clsx('main-live-page', {
        fullscreen: handleFullScreen.active,
        noneFullScreen: !handleFullScreen.active,
      })}
      style={{
        position: 'relative',
        width: '100%',
        top: 0,
        overflow: 'auto',
      }}
    >
      {data.map(camera => (
        <CameraItem
          layout={layout}
          key={camera.serial}
          camera={camera}
          isSelected={false}
          onDoubleClick={() => {
            setLayoutMode('single');
            setSelectedStream(camera);
          }}
          onClick={() => {}}
          generateLinkStorageFileByTime={generateLinkStorageFileByTime}
          getAppearanceTimeStyle={getAppearanceTimeStyle}
          playerRefs={playerRefs}
          handleProgress={handleProgress}
          isSeeking={isSeeking}
        />
      ))}
    </Row>
  );
};

export default CameraList;
